import { useContext, useEffect } from 'react';

import { isEmpty } from '@ajaibid/utils';
import { StockBuySellContext } from '@context/stock/buysell';

import { getAccountType, getOrderType, getOrderPeriod, getAutoThresholdComparator } from '../utils';

const useInitAmendForm = ({ orderDetail }) => {
  const code = orderDetail?.code ?? '';

  const { formKey, formAction, dispatch, setActiveCode } = useContext(StockBuySellContext);

  // Setup form on first render
  useEffect(() => {
    if (!code) return;

    dispatch({ type: formAction.SETUP_FORM_AMEND, code });
    setActiveCode(code);
  }, [code]);

  // Update form on API data received
  useEffect(() => {
    if (!code) return;
    if (isEmpty(orderDetail)) return;

    dispatch({
      type: formAction.CHANGE_INPUT_FROM_API,
      code,
      payload: {
        // General order details
        [formKey.CONST_ORDER_ID]: orderDetail?.order_id,
        [formKey.CONST_IDX_ORDER_ID]: orderDetail?.idx_order_id,
        [formKey.CONST_STATUS]: orderDetail?.status,
        [formKey.INPUT_ORDER_SIDE]: orderDetail?.order_side,
        [formKey.INPUT_ACCOUNT_TYPE]: getAccountType(orderDetail),
        [formKey.TAB_ORDER_TYPE]: getOrderType(orderDetail),
        [formKey.INPUT_ORDER_PERIOD]: getOrderPeriod(orderDetail),
        // Limit order details
        [formKey.INPUT_PRICE]: orderDetail?.price,
        [formKey.INPUT_LOT_COUNT]: orderDetail?.lot_count,
        [formKey.CALC_ORDER_TOTAL]: orderDetail?.total,
        // Auto order details
        ...(orderDetail?.order_type === 'AUTO'
          ? {
              [formKey.INPUT_START_DATE]: orderDetail?.start_date,
              [formKey.INPUT_END_DATE]: orderDetail?.end_date,
              [formKey.INPUT_THRESHOLD_COMPARATOR]: getAutoThresholdComparator(orderDetail),
              [formKey.INPUT_THRESHOLD_VALUE]: orderDetail?.threshold_value,
            }
          : {}),
        // API Data
        [formKey.CONST_MAX_LOT_AMEND]: orderDetail?.lot_count,
      },
    });
  }, [orderDetail, code]);

  // Cleanup form on unmount
  useEffect(() => {
    return () => {
      if (!code) return;
  
      dispatch({ type: formAction.RESET_STOCK_FORM, code });
    };
  }, [code]);
};

export default useInitAmendForm;
